import { c as __assign } from './tslib.es6-b10543c1.js';
import React__default from 'react';
import { U as UltimateSpecialOffers } from './UltimateSpecialOffers-781bf22d.js';

var SpecialOffers = function (props) {
    return React__default.createElement(UltimateSpecialOffers, __assign({}, props));
};

export { SpecialOffers as S };
//# sourceMappingURL=SpecialOffers-e258bbb7.js.map
